<template>
    <img :src="getImage" :alt="alt" @mouseenter="showSecondImage" @mouseleave="showFirstImage" />
</template>

<script>

export default {
    props: {
        'image': {},
        'use_random_test_images': {default: true},
        'show_different_image_on_hover': {default: false},
        'image_on_hover': {default: ''},
        'alt': {default: ''}
    },
    data() {
        return {
            force_refresh_computed: 0,
            hovering: false
        }
    },
    computed: {
        getImage(){
            this.force_refresh_computed; //Mentioning this here forces function to trigger after incrementing
            let image = this.image;

            if(this.show_different_image_on_hover && this.hovering){
                image = this.image_on_hover
            }

            return this.getDynamicProductImage(image, this.use_random_test_images);
        }
    },
    methods:{
        showSecondImage(){
            if(this.show_different_image_on_hover && this.image_on_hover != ''){
                this.hovering = true;
                this.force_refresh_computed++;
            }
        },
        showFirstImage(){
            if(this.show_different_image_on_hover){
                this.hovering = false;
                this.force_refresh_computed++;
            }
        },
        getDynamicProductImage(image, random_test_image = true){
            //try{
                //TEST IMAGES ONLY ---- REMOVE LATER
                // if(random_test_image){
                //     let number = Math.floor(Math.random() * 10) +1;
                //     image = `products/product_${number}.png`;
                // }

                // return require(`@/ecom/assets/images/${image}`);
                    return `/images/${image}`;
            //}
            //catch(e){
               // try{
               //     return require(`@/ecom/assets/images/products/default.jpg`);
              //  }
             //   catch(e){
               //     return '';
             //   }
            //}
        }
    }
}
</script>